import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import { SliceKeys, tablePaginationInitialValue } from "@sso/constant";
import { RootState } from "@sso/store";
import { getTableSortColumn, queryBuilder } from "@sso/utils";

export const PricingSlice = createSlice({
  name: SliceKeys.PRICING,
  initialState: { softwareLicenceId: "", pagination: tablePaginationInitialValue },
  reducers: {
    setPricingSoftwareLicenceId: (state, action: PayloadAction<string>) => {
      state.softwareLicenceId = action.payload;
    },
    setPricingPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.pageSize = action.payload;
    },
    setPricingPageIndex: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = action.payload;
    },
    setPricingSortColumn: (state, action: PayloadAction<string>) => {
      const { column, type } = state.pagination.sort;
      state.pagination.sort = getTableSortColumn(column, action.payload, type);
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    },
  },
});

export const { setPricingSoftwareLicenceId, setPricingPageSize, setPricingPageIndex, setPricingSortColumn } =
  PricingSlice.actions;

export const selectPricingSoftwareLicenceId = (state: RootState) => state.pricing.softwareLicenceId;

export const selectPricingPagination = createSelector(
  (state: RootState) => state.pricing.pagination,
  ({ pageSize, totalPages, pageIndex, sort, search }) => ({
    pageSize: { action: setPricingPageSize, value: pageSize },
    pagination: {
      totalPages,
      pageIndex,
      action: setPricingPageIndex,
    },
    sort,
  }),
);

// needs to build query with software licence id too
export const selectPricingQuery = createSelector(
  (state: RootState) => state.pricing,
  ({ pagination, softwareLicenceId }) =>
    `${queryBuilder(
      pagination.pageSize,
      pagination.pageIndex,
      pagination.search,
      pagination.sort,
    )}&softwareLicenceId=${softwareLicenceId}`,
);

export default PricingSlice.reducer;
